<template>
 <header id="header">
  <div v-if="modal" id="modal">
    <div class="card card-modal">
      <svg @click="closeModal()" id="close-modal" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
        <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"></path>
      </svg>
      <div class="qrcode">
        <img src="../assets/qrcode.png" />
      </div>
      <div class="text-qrcode">
        <button id="btn-copypix" @click="copyPix()" :disabled="!pixCode">{{ pixCode ? 'Chave Copia/Cola' : 'Carregando...' }}</button>
        <span v-if="churchInfo.cnpj">CNPJ: {{ churchInfo.cnpj }}</span>
        <span v-if="churchInfo.church_name">{{ churchInfo.church_name }}</span>
      </div>
    </div>
  </div>
  <div class="header-container">
   <a href="/">
    <img id="logo" src="../assets/logo.png" alt="logo elshaday" />
   </a>
   <span class="menu-mobile" @click="toggleMobileMenu">
    <svg v-if="!isMobileMenuOpen" key="menu-open-icon" viewBox="0 0 100 80" width="30" height="30" fill="#2c3e50">
     <rect width="100" height="15" rx="8"></rect>
     <rect y="30" width="100" height="15" rx="8"></rect>
     <rect y="60" width="100" height="15" rx="8"></rect>
    </svg>
    <!-- <svg v-else key="menu-close-icon" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="#2c3e50">
      <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"></path>
    </svg> -->
   </span>
   <ul class="desktop-menu">
    <router-link to="/">
     <li>INÍCIO</li>
    </router-link>
    <router-link to="/ministracoes">
     <li>MINISTRAÇÕES</li>
    </router-link>
    <a :href="churchInfo.calendario_url || '#'" target="_blank">
     <li>CALENDÁRIO</li>
    </a>
    <a :href="locationLink" target="_blank">
     <li>COMO CHEGAR</li>
    </a>
    <li @click="openModal()">CONTRIBUA</li>
   </ul>
  </div>
  <transition name="slide-fade">
    <div v-if="isMobileMenuOpen" class="mobile-menu-panel">
      <svg @click="toggleMobileMenu()" class="close-menu-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 30 30">
        <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"></path>
      </svg>
      <ul>
        <router-link to="/" @click="toggleMobileMenu">
         <li>INÍCIO</li>
        </router-link>
        <router-link to="/ministracoes" @click="toggleMobileMenu">
         <li>MINISTRAÇÕES</li>
        </router-link>
        <a :href="churchInfo.calendario_url || '#'" target="_blank" @click="toggleMobileMenu">
         <li>CALENDÁRIO</li>
        </a>
        <a :href="locationLink" target="_blank" @click="toggleMobileMenu">
         <li>COMO CHEGAR</li>
        </a>
        <li @click="openModalAndCloseMenu()">CONTRIBUA</li>
      </ul>
    </div>
  </transition>
 </header>
</template>

<script>
import { getLocationLink } from "@/utils/location.js";

export default {
 name: "HeaderVue",
 props: {
  msg: String,
  latitude: Number,
  longitude: Number,
  churchInfo: {
    type: Object,
    default: () => ({})
  },
 },
 data() {
  return {
    modal: false,
    isMobileMenuOpen: false,
  }
 },
 computed: {
    pixCode() {
      return this.churchInfo.pix_code || ''
    },
    locationLink() {
      return getLocationLink(this.latitude, this.longitude)
    }
  },
 methods: {
  openModal() {
    document.body.style.overflow = "hidden";
    this.modal = true;
  },
  closeModal() {
    if (!this.isMobileMenuOpen) {
      document.body.style.overflow = "auto";
    }
    this.modal = false;
  },
  async copyPix() {
    if (!this.pixCode) return
    try {
      await navigator.clipboard.writeText(this.pixCode)
      this.$emit('toast-success', 'Chave Pix copiada com sucesso!')
    } catch {
      this.$emit('toast-success', 'Erro ao copiar chave Pix. Copie manualmente.')
    }
  },
  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
    if (this.isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      // Only set overflow to auto if modal is not open
      if (!this.modal) {
        document.body.style.overflow = "auto";
      }
    }
  },
  openModalAndCloseMenu() {
    this.openModal(); // This will set body overflow to hidden
    this.isMobileMenuOpen = false;
    // No need to change body.style.overflow here, modal is open
  }
 }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#modal {
  position: fixed; /* Changed from absolute to fixed for better modal behavior */
  top: 0;
  left: 0; /* Added left: 0 for fixed positioning */
  width: 100vw;
  height: 100vh; /* Changed from 110vh to 100vh */
  background: rgba(0, 0, 0, 0.86);
  /* overflow: hidden; no longer needed here, handled by body */
  z-index: 10001; /* Higher than mobile menu panel */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
}
.card-modal {
  position: relative;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 20px;
  gap: 20px;
}
.text-qrcode {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
}
#btn-copypix {
  padding: 8px 15px;
  border-radius: 10px;
  border: solid 1px #2c3e50;
  background: transparent;
}
#close-modal {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
}
header {
 background: #fff;
 padding: 20px 0;
 box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.13);
}
.header-container {
 margin: 0 auto;
 display: flex;
 justify-content: space-between;
 align-items: center;
 max-width: 1080px;
}
#logo {
 width: 120px;
}
.desktop-menu { /* Renamed from header ul to be more specific */
 font-size: 15px;
 list-style-type: none;
 padding: 0;
 display: flex;
 gap: 20px;
}
header a { /* Applies to links in desktop menu */
 text-decoration: none !important;
 color: #2c3e50;
}
header .desktop-menu li {
 display: inline-block;
 margin: 0 10px;
 cursor: pointer;
 opacity: 0.9;
 transition: all 0.3s ease-in-out;
}
header .desktop-menu li:hover {
 opacity: 1;
 color: #3366cc;
}

.menu-mobile {
 display: none; /* Hidden by default, shown in media query */
 cursor: pointer;
 /* Removed border and padding to make it cleaner, icon is the visual cue */
 z-index: 10001; /* Ensure it's above other header content if overlapping */
}
.menu-mobile svg {
  display: block; /* Remove extra space below SVG */
}

.mobile-menu-panel {
  position: fixed;
  top: 0;
  right: 0;
  width: 85%; /* Adjust width as desired */
  max-width: 320px; /* Max width for larger mobile screens */
  height: 100vh;
  background-color: #ffffff; /* Clean white background */
  box-shadow: -3px 0px 15px rgba(0, 0, 0, 0.2); /* Shadow on the left */
  z-index: 10000; /* High z-index */
  padding-top: 60px; /* Space for close button or header */
  overflow-y: auto; /* Allow scrolling if content exceeds height */
}

.close-menu-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  fill: #2c3e50; /* Match icon color */
}

.mobile-menu-panel ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}

.mobile-menu-panel a, .mobile-menu-panel li {
  text-decoration: none;
  color: #2c3e50; /* Dark text for readability */
  display: block;
  width: 100%;
  padding: 18px 25px; /* Increased padding for tap targets and visual appeal */
  font-size: 1.1em; /* Slightly larger font size */
  border-bottom: 1px solid #f0f0f0; /* Subtle separator */
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.mobile-menu-panel a:hover, .mobile-menu-panel li:hover {
  background-color: #f5f5f5; /* Light background on hover */
  color: #3366cc; /* Accent color on hover */
}
.mobile-menu-panel a:last-of-type li,
.mobile-menu-panel li:last-child {
  border-bottom: none;
}
.mobile-menu-panel a li { /* Reset padding if 'a' already has it */
  padding: 0;
  border-bottom: none; /* Handled by 'a' or parent 'li' */
}


/* Transition styles */
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}


@media screen and (max-width: 1110px) {
 .header-container {
  padding: 0px 40px;
 }
}

@media screen and (max-width: 811px) {
 header {
  padding: 10px 0; /* Consider adjusting if icon looks cramped */
 }
 .desktop-menu { /* Hide desktop menu */
  display: none;
 }
 .menu-mobile { /* Show hamburger icon */
  display: block;
  padding: 5px; /* Add some padding around the icon for easier tapping */
 }
 /* .mobile-menu-panel display is controlled by v-if, not media query */
}
@media screen and (max-width: 522px) {
  .qrcode {
    margin-top: 50px;
    width: 700px;
  }
  .qrcode img {
    width: 100%;
  }
}
@media screen and (max-width: 496px) {
 .header-container {
  padding: 0px 15px;
  justify-content: space-between;
 }
}
</style>
